import { ExcelTool } from '../../../../core/excel/excel_tool';
import { IDs } from '../../../../helpers/IDs';

export class ImportGtz {

    public constructor(data: any) {
        this.data = data;
        this.orteIds = (this.data[IDs.ENT_GTZ_ORTE] || [])
            .map((item: any) => item.id || null);
    }

    private data: any;
    private dataInsert: any[] = [];
    private dataOrte: any[] = [];
    private orteIds: number[] = [];

    public setData(data: any, startRow: number = 2): void {
        this.getSheetData(data, (startRow - 1));
    }

    public getData(): any[] {
        return [
            ...this.dataInsert,
            ...this.dataOrte
        ];
    }

    public getDataInsert(): any[] {
        return this.dataInsert;
    }

    public getDataOrte(): any[] {
        return this.dataOrte;
    }

    private getSheetData(data: any, startRow: number): void {
        const excel = new ExcelTool();
        const workbook: any = excel.getWorkbook(data, 'string', { raw: true }) || {};
        const sheets: any[] = workbook.SheetNames || [];

        if (!sheets || !sheets.length) {
            return;
        }
        const dataSheet: any[] = excel.getJSON(workbook, sheets[0]);

        if (dataSheet.length && dataSheet[0].length !== 2) {
            return;
        }

        dataSheet.forEach((row: string[], index: number) => {
            if (index < startRow) {
                return;
            }
            const [id, geogr_breite, geogr_laenge, station, monat, , monatsgradtage, , mittelwert] = row;
            const jahrMonat: string = (monat || '').toString();
            const ort: string = (station || '').trim();
            const ortTid: number = +id || null;

            if (jahrMonat.length !== 6 || !ortTid) {
                return;
            }

            if (this.orteIds.indexOf(ortTid) === -1) {
                this.orteIds.push(ortTid);
                this.dataOrte.push({
                    id: +ortTid,
                    latitude: +geogr_breite,
                    longitude: +geogr_laenge,
                    ort
                });
            }
            this.dataInsert.push({
                monat: +jahrMonat.substring(4),
                jahr: +jahrMonat.substring(0, 4),
                gtz: +monatsgradtage || 0,
                mittel_10_jahre: +mittelwert || 0,
                ort_tid: ortTid
            });
        });
    }
}
